import React, { useEffect, useState } from "react";
import _ from 'lodash';
import { useParams, useHistory } from 'react-router';
import { useSelector, useDispatch } from "react-redux";
import { getCurrencyFormat, getLocalStorageData, LOCAL_STORAGE_ITEMS_NAMES } from "../../../RestaurantWidget/utilities/helper/helper";
import { Col, Icon, Row, TextArea, Typography } from "witmeg-ui-system";
import "./VoucherDefaultSingleItemPage.scss";
import arrow from "../../assets/images/down-arrow.svg";
import { Radio, Checkbox, } from 'antd';
import { v4 as uuidv4 } from 'uuid';
import { addToCart, deleteCartItem, getCartItemsToCart } from "../../../RestaurantWidget/utilities/api/restaurantsService";
import spiceImage from "../../assets/images/spice-level.svg"
import { fetchAllRestaurantMenuData, setOrderCartItems, setOrderData, setOrderEmpty } from "../../../../../../../redux/resturantWidgetSlice";
import deleteIc from "../../assets/trash.svg"
import DeletePopup from "../../components/Cart/DeletePopup";

import IMAGE_PLACEHOLDER from '../../assets/images/Images/vouchers-placeholder.jpg'
const VoucherDefaultSingleItemPage = () => {
    const [isLoading, setIsLoading] = useState(false)
    const [isDelete, setIsDelete] = useState(false)


    const [item, setItem] = useState(localStorage.getItem("ITEM") ? JSON.parse(localStorage.getItem("ITEM")) : null);
    const showContent = (itemValue) => {
        let list = ["Ingredients", "Nutritional", "Instructions", "Allergies"];
        if (itemValue) {
            if (!itemValue?.DishInfo?.Classifications?.Ingredients || itemValue?.DishInfo?.Classifications?.Ingredients?.length === 0) {
                list = list.filter(content => content !== "Ingredients");
            }
            if (!itemValue?.Allergens || itemValue?.Allergens?.length === 0) {
                list = list.filter(content => content !== "Allergies");
            }
            if (itemValue?.DishInfo?.Classifications?.InstructionsForUse || itemValue?.DishInfo?.Classifications?.InstructionsForUse === "") {
                list = list.filter(content => content !== "Instructions");
            }
        }

        return list;
    };
    const [selectedDetails, setSelectedDetails] = useState(showContent(item)[0]);
    const [comments, setComments] = useState("");
    const [isOpen, setIsOpen] = useState([]);
    const [quantities, setQuantities] = useState(localStorage.getItem("QUANTITY") ? JSON.parse(localStorage.getItem("QUANTITY")) : []);
    const [cartDetails, setCartDetails] = useState({});
    const params = useParams();
    const dispatch = useDispatch();
    const history = useHistory()
    const {
        menuData: {
            storage: { data }
        },
        currency,
        selectedOrderType
    } = useSelector((state) => state.resturantData);
    const { companyDetails } = useSelector((state) => state.companyData);
    const restaurantDataState = useSelector((state) => state.resturantData);
    const currencyFormat = getCurrencyFormat(currency);
    //getting order type for cart
    const getOrderType = () => {
        let type;
        switch (selectedOrderType) {
            case "delivery":
                type = "DELIVERY_BY_REWARDCONSUMER";
                break;
            case "table":
                type = "DINE_IN";
                break;
            case "collection":
                type = "TAKE_AWAY";
                break;
            default:
                type = "DELIVERY_BY_REWARDCONSUMER";
                break;
        }
        return type
    }
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    useEffect(() => {
        const fetchData = async () => {
            const val = await getLocalStorageData(LOCAL_STORAGE_ITEMS_NAMES.ECOM_CART_DATA);
            const userDetails = localStorage.getItem('fullUserDetails')
            let parsedUserDetails = JSON.parse(localStorage.getItem('fullUserDetails'))
            let customer = {
                ID: localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_USER_ID),
                Name: {
                    DisplayName: userDetails ? parsedUserDetails.UserName : "",
                    FirstName: userDetails ? parsedUserDetails.FirstName : "",
                    LastName: userDetails ? parsedUserDetails.LastName : "",
                },
                Email: userDetails ? parsedUserDetails.Email : "",
                IsPrimaryCustomer: true

            }
            let cart = {
                "OrderID": localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_CART_ORDER_ID) ? localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_CART_ORDER_ID) : '',
                "StoreID": val.cloudLocationID,
                "ConsumerID": localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_USER_ID),
                "OrderingPlatformType": "RETAILPACX",
                "CountryISOCode": "GB",
                "OrganizationID": val.organizationID,
                "CloudLocationID": val.cloudLocationID,
                "Name": companyDetails.shopName,
                "OrderFullFilmentType": getOrderType(),
                "Customers": [customer]
            }
            setCartDetails(cart)
            dispatch(fetchAllRestaurantMenuData({
                CloudLocationID: val.cloudLocationID,
                OrganizationID: val.organizationID,
            }));
        };
        fetchData();
    }, [dispatch]);
    useEffect(() => {
        if (data && data.Items) {
            const selectedItem = _.find(data.Items, { MenuItemID: params.id });
            if (selectedItem) {
                let commentValue = params.itemId !== "new" ? JSON.parse(localStorage.getItem("QUANTITY"))[0].CustomerRequests.SpecialInstructions : ""
                setComments(commentValue)
                let newQuantityValue = localStorage.getItem("QUANTITY") ? JSON.parse(localStorage.getItem("QUANTITY"))[0].Quantity.Amount : 1
                let cartObject = {
                    "CartItemID": selectedItem.MenuItemID,
                    "Title": selectedItem.Title?.en,
                    "CustomerID": localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_USER_ID),
                    "Quantity": {
                        "Unit": "pcs",
                        "Amount": newQuantityValue
                    },
                    "DefaultQuantity": {
                        "Amount": 1,
                        "Unit": "pcs"
                    },
                    "CustomerRequests": {
                        "Allergy": {
                            "Allergens": [],
                            "Instructions": ""
                        },
                        "SpecialInstructions": comments
                    },
                    SelectedModifierGroups: [],
                    Id: uuidv4(),
                    ID: params.itemId !== "new" ? params.itemId : "",
                    ModifierGroupRules: selectedItem.ModifierGroupRules,
                    Image: selectedItem.ImageURL,
                    PriceInfo: getItemPriceForCart(selectedItem.PriceInfo, newQuantityValue)

                }

                let newItem = { ...selectedItem, Quantity: newQuantityValue, SelectedModifierGroups: [], Id: uuidv4() }
                let newQuantity = localStorage.getItem("QUANTITY") ? JSON.parse(localStorage.getItem("QUANTITY")) : [cartObject]
                setItem(newItem);
                setSelectedDetails(showContent(newItem)[0])

                localStorage.setItem("ITEM", JSON.stringify(newItem))
                if (JSON.parse(localStorage.getItem("QUANTITY"))) {
                    let quantityStorage = JSON.parse(localStorage.getItem("QUANTITY"))
                    let value = [{ ...quantityStorage[0], ModifierGroupRules: selectedItem.ModifierGroupRules, }]
                    setQuantities(value)
                    localStorage.setItem("QUANTITY", JSON.stringify(value))

                } else {
                    setQuantities(newQuantity)
                    localStorage.setItem("QUANTITY", JSON.stringify(newQuantity))
                }
            }
        }
    }, [data, params.id]);
    const getType = () => {
        let type;
        switch (selectedOrderType) {
            case "delivery":
                type = "Delivery";
                break;
            case "table":
                type = "DineIn";
                break;
            case "collection":
                type = "Takeaway";
                break;
            default:
                type = "Delivery";
                break;
        }

        return type;
    };
    const getThePriceItem = (overrides, Id, quantity) => {
        let price = getOptionPriceForCart(overrides, Id, quantity).BaseTotalPrice
        let priceValue;
        switch (selectedOrderType) {
            case "delivery":
                priceValue = price.Delivery.FormattedText;
                break;
            case "table":
                priceValue = price.DineIn.FormattedText;
                break;
            case "collection":
                priceValue = price.TakeAway.FormattedText;
                break;
            default:
                priceValue = price.Delivery.FormattedText;
                break;
        }

        return priceValue;
    };
    const getPriceSelectedOption = (selectedItem) => {
        let price = selectedItem.PriceInfo.BaseTotalPrice
        let priceValue;
        switch (selectedOrderType) {
            case "delivery":
                priceValue = price.Delivery.FormattedText;
                break;
            case "table":
                priceValue = price.DineIn.FormattedText;
                break;
            case "collection":
                priceValue = price.TakeAway.FormattedText;
                break;
            default:
                priceValue = price.Delivery.FormattedText;
                break;
        }
        return priceValue;
    }
    const getOptionPrice = (overrides, Id, quantity) => {
        let option = _.find(overrides, { ContextValue: Id })
        if (option) {
            return getThePriceItem(overrides, Id, quantity)
        } else {
            return "£0.00"
        }

    }
    const getOptionPriceForCart = (overrides, Id, quantity) => {
        const option = _.find(overrides, { ContextValue: Id });
        const createPriceObj = (price, quantity) => ({
            Amount: price * quantity,
            FormattedText: currencyFormat((price * quantity) / 100),
            FormattedAmount: Number(((price * quantity) / 100).toFixed(2))
        });

        const getPriceData = (price, quantity) => ({
            Delivery: createPriceObj(price?.DeliveryPrice || 0, quantity),
            TakeAway: createPriceObj(price?.PickupPrice || 0, quantity),
            DineIn: createPriceObj(price?.TablePrice || 0, quantity),
            CurrencyCode: cartDetails.currency
        });

        const basePrice = getPriceData(option?.Price || {}, 1);
        const totalPrice = getPriceData(option?.Price || {}, quantity);

        return {
            BaseUnitPrice: basePrice,
            BaseTotalPrice: quantity > 1 ? totalPrice : basePrice
        };
    };
    const getItemPriceForCart = (option, quantity) => {
        const createPriceObj = (price, quantity) => ({
            Amount: price * quantity,
            FormattedText: currencyFormat((price * quantity) / 100),
            FormattedAmount: Number(((price * quantity) / 100).toFixed(2))
        });

        const getPriceData = (price, quantity) => ({
            Delivery: createPriceObj(price?.DeliveryPrice || 0, quantity),
            TakeAway: createPriceObj(price?.PickupPrice || 0, quantity),
            DineIn: createPriceObj(price?.TablePrice || 0, quantity),
            CurrencyCode: cartDetails.currency
        });

        const basePrice = getPriceData(option?.Price || {}, 1);
        const totalPrice = getPriceData(option?.Price || {}, quantity);
        return {
            BaseUnitPrice: basePrice,
            BaseTotalPrice: quantity > 1 ? totalPrice : basePrice
        };
    };
    const updatePrice = (priceInfo, qty) => {
        let totalsVal = {
            "Delivery": {
                "Amount": priceInfo.BaseUnitPrice.Delivery.Amount * qty,
                "FormattedText": currencyFormat((priceInfo.BaseUnitPrice.Delivery.Amount * qty) / 100),
                "FormattedAmount": Number(((priceInfo.BaseUnitPrice.Delivery.Amount * qty) / 100).toFixed(2))
            },
            "TakeAway": {
                "Amount": priceInfo.BaseUnitPrice.TakeAway.Amount * qty,
                "FormattedText": currencyFormat((priceInfo.BaseUnitPrice.TakeAway.Amount * qty) / 100),
                "FormattedAmount": Number(((priceInfo.BaseUnitPrice.TakeAway.Amount * qty) / 100).toFixed(2))
            },
            "DineIn": {
                "Amount": priceInfo.BaseUnitPrice.DineIn.Amount * qty,
                "FormattedText": currencyFormat((priceInfo.BaseUnitPrice.DineIn.Amount * qty) / 100),
                "FormattedAmount": Number(((priceInfo.BaseUnitPrice.DineIn.Amount * qty) / 100).toFixed(2))

            },
            "CurrencyCode": "GBP"
        }
        let price = { ...priceInfo, BaseTotalPrice: totalsVal }
        return price
    }

    //increase Item quantity
    const increaseQty = () => {
        let newItem = { ...item, Quantity: item.Quantity ? item.Quantity + 1 : 1 }
        setItem(newItem)
        localStorage.setItem("ITEM", JSON.stringify(newItem))
        let update = {
            ...quantities[0], Quantity: {
                ...quantities[0].Quantity, Amount: newItem.Quantity,

            }, PriceInfo: getItemPriceForCart(newItem.PriceInfo, newItem.Quantity)
        }
        setQuantities([update])
        localStorage.setItem("QUANTITY", JSON.stringify([update]))

    };

    //decrease Item quantity
    const decreaseQty = () => {
        if (item.Quantity > 1) {
            let newItem = { ...item, Quantity: item.Quantity ? item.Quantity - 1 : 0 }
            setItem(newItem)
            localStorage.setItem("ITEM", JSON.stringify(newItem))
            let update = {
                ...quantities[0], Quantity: {
                    ...quantities[0].Quantity, Amount: newItem.Quantity,
                },
                PriceInfo: getItemPriceForCart(newItem.PriceInfo, newItem.Quantity)
            }
            setQuantities([update])
            localStorage.setItem("QUANTITY", JSON.stringify([update]))
            if (newItem.Quantity === 0) {
                setQuantities([])
                localStorage.removeItem("QUANTITY")
            }
        } else {
            if (params.itemId !== "new") {
                setIsDelete(true)
            }
        }
    };
    const handleDelete = () => {
        let cartArray = restaurantDataState.orderCartData.Items.filter((cartItem) => cartItem.ID !== params.itemId)
        dispatch(setOrderCartItems(cartArray))
        deleteCartItem(params.itemId).then((response) => {
            if (response) {
                if (restaurantDataState.orderCartData.Items.length > 1) {
                    let customerID = localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_USER_ID);
                    let cloud = JSON.parse(localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_DATA)).cloudLocationID
                    getCartItemsToCart(customerID, cloud).then((response) => {
                        if (response) {
                            dispatch(setOrderData(response))
                        }
                    })
                }
                else {
                    dispatch(setOrderEmpty())
                }
                history.push('/item/' + item.MenuItemID + "/" + "new")
                setIsDelete(false)
            }
        })
    }

    const toggleModifierGroup = (id) => {
        setIsOpen((prevIsOpen) => {
            if (prevIsOpen.includes(id)) {
                return prevIsOpen.filter((groupId) => groupId !== id);
            } else {
                return [...prevIsOpen, id];
            }
        });
    };

    const flattenArray = (arr) => {
        let result = [];
        arr.forEach(item => {
            result.push(item);
            if (item.SelectedModifierGroups && item.SelectedModifierGroups.length > 0) {
                result = result.concat(flattenArray(item.SelectedModifierGroups));
            }
        });
        return result;
    };

    //update childre modifiers qunatities
    const updateChildQuantities = (child, multiplier, isIncreasing = true) => {
        if (child.SelectedModifierGroups.length > 0) {
            child.SelectedModifierGroups.forEach(selectedMod => {
                selectedMod.SelectedItems.forEach(selected => {
                    if (isIncreasing) {
                        selected.Quantity.Amount = multiplier * selected.Quantity.Amount;
                        selected.PriceInfo = updatePrice(selected.PriceInfo, selected.Quantity.Amount)

                    } else {
                        if (selected.Quantity.Amount !== 1) {
                            selected.Quantity.Amount = Math.round(selected.Quantity.Amount / multiplier);
                            selected.PriceInfo = updatePrice(selected.PriceInfo, selected.Quantity.Amount)
                        }
                    }
                    updateChildQuantities(selected, child.Quantity.Amount, isIncreasing);
                });
            });
        }
    }

    //update modifier qunatities (increase)
    const updateParentQuantities = (prev = [], optionValue, modifierVal, parent) => {
        return new Promise((resolve, reject) => {
            const updatedQuantities = JSON.parse(JSON.stringify(prev || []))
            let option = {
                CartItemID: optionValue.MenuItemID ? optionValue.MenuItemID : optionValue.CartItemID,
                Title: optionValue?.Title?.en ? optionValue?.Title.en : optionValue?.Title,
                Id: optionValue.Id,
                ParentID: optionValue.ParentID,
                Quantity:
                    { Unit: "pcs", Amount: optionValue.Quantity ? optionValue.Quantity.Amount : 1 },
                SelectedModifierGroups: [],
                ModifierGroupRules: optionValue.ModifierGroupRules,
                PriceInfo: getOptionPriceForCart(optionValue?.PriceInfo?.Overrides, modifierVal.ModifierGroupID, optionValue.Quantity ? optionValue.Quantity.Amount : 1)
            }

            if (!option) {
                return resolve(updatedQuantities);
            }
            const updateRecursive = (item, modifier, parentValue) => {
                return new Promise((resolveRecursive, rejectRecursive) => {
                    const sameParent = item.ModifierGroupRules.IDs.findIndex(id => id === modifier.ModifierGroupID)
                    if (sameParent !== -1) {
                        if (item.SelectedModifierGroups.length > 0) {
                            const parentIndex = item.SelectedModifierGroups.findIndex(it => it.ID === modifier.ModifierGroupID);
                            if (parentIndex !== -1) {
                                const itemValue = item.SelectedModifierGroups[parentIndex];
                                const optionIndex = itemValue.SelectedItems.findIndex(o => o.CartItemID === option.CartItemID)
                                if (item.Id === option.ParentID) {
                                    if (optionIndex !== -1) {
                                        itemValue.SelectedItems[optionIndex].Quantity.Amount += 1;
                                        itemValue.SelectedItems[optionIndex].PriceInfo = updatePrice(itemValue.SelectedItems[optionIndex].PriceInfo, itemValue.SelectedItems[optionIndex].Quantity.Amount)
                                        if (itemValue.SelectedItems.length > 0) {
                                            itemValue.SelectedItems.forEach(child => {
                                                if (option.Id === child.Id) {
                                                    updateChildQuantities(child, itemValue.SelectedItems[optionIndex]?.Quantity.Amount, true);
                                                }
                                            });
                                        }
                                        resolveRecursive();
                                    } else {
                                        itemValue.SelectedItems.push({
                                            ...option,
                                            Quantity: { Unit: "pcs", Amount: 1 },
                                        })
                                        resolveRecursive();
                                    }
                                }
                            } else {
                                item.SelectedModifierGroups.push({
                                    SelectedItems: [{
                                        ...option,
                                        Quantity: { Unit: "pcs", Amount: 1 },
                                    }],
                                    ID: modifier.ModifierGroupID,
                                    Title: modifier.Title.en,
                                    ModifierOptions: modifier.ModifierOptions,
                                    QuantityConstraintsRules: modifier.QuantityConstraintsRules,
                                    ParentID: modifier.ParentID
                                });
                                resolveRecursive();
                            }

                        } else {
                            if (item.Id === option.ParentID) {
                                item.SelectedModifierGroups.push({

                                    SelectedItems: [{
                                        ...option,
                                        Quantity: { Unit: "pcs", Amount: 1 },
                                    }],
                                    ID: modifier.ModifierGroupID,
                                    Title: modifier.Title.en,
                                    ModifierOptions: modifier.ModifierOptions,
                                    QuantityConstraintsRules: modifier.QuantityConstraintsRules,
                                    ParentID: modifier.ParentID
                                });
                                resolveRecursive();
                            }
                        }
                    } else {
                        for (let mod of item.SelectedModifierGroups) {
                            for (let childMod of mod.SelectedItems) {
                                updateRecursive(childMod, modifier, parentValue).then(() => resolve(updatedQuantities))
                                    .catch(reject);

                            }
                        }

                    }
                });
            };

            updateRecursive(updatedQuantities[0], modifierVal, parent)
                .then(() => resolve(updatedQuantities))
                .catch(reject);
        });
    };

    //wrapper function to add modifier qunatity
    const addQtyOfModifiers = async (option, modifier, parent) => {
        try {
            const updated = await updateParentQuantities(quantities, option, modifier, parent);
            setQuantities(updated);
            localStorage.setItem("QUANTITY", JSON.stringify(updated))
        } catch (error) {
            console.error('Error updating quantities:', error);
        }
    };

    //update modifier qunatities (decrease)
    const reduceParentQuantities = (prev = [], optionValue, modifierVal, parent) => {
        return new Promise((resolve, reject) => {
            const updatedQuantities = JSON.parse(JSON.stringify(prev || []));
            let option = {
                CartItemID: optionValue.MenuItemID ? optionValue.MenuItemID : optionValue.CartItemID,
                Title: optionValue?.Title?.en ? optionValue?.Title.en : optionValue?.Title,
                Id: optionValue.Id,
                ParentID: optionValue.ParentID,
                Quantity:
                    { Unit: "pcs", Amount: optionValue.Quantity ? optionValue.Quantity.Amount : 1 },
                SelectedModifierGroups: [],
                ModifierGroupRules: optionValue.ModifierGroupRules,
                PriceInfo: getOptionPriceForCart(optionValue?.PriceInfo?.Overrides, modifierVal.ModifierGroupID, optionValue.Quantity ? optionValue.Quantity.Amount : 1)
            };

            if (!option) {
                return resolve(updatedQuantities);
            }

            const reduceRecursive = (item, modifier, parentValue) => {
                return new Promise((resolveRecursive, rejectRecursive) => {
                    const sameParent = item.ModifierGroupRules.IDs.findIndex(id => id === modifier.ModifierGroupID);
                    if (sameParent !== -1) {
                        if (item.SelectedModifierGroups.length > 0) {
                            const parentIndex = item.SelectedModifierGroups.findIndex(it => it.ID === modifier.ModifierGroupID);
                            if (parentIndex !== -1) {
                                const itemValue = item.SelectedModifierGroups[parentIndex];
                                const optionIndex = itemValue.SelectedItems.findIndex(o => o.CartItemID === option.CartItemID);

                                if (item.Id === option.ParentID) {
                                    if (optionIndex !== -1) {
                                        if (itemValue.SelectedItems[optionIndex].Quantity.Amount > 1) {
                                            itemValue.SelectedItems[optionIndex].Quantity.Amount -= 1;
                                            itemValue.SelectedItems[optionIndex].PriceInfo = updatePrice(itemValue.SelectedItems[optionIndex].PriceInfo, itemValue.SelectedItems[optionIndex].Quantity.Amount)
                                            if (itemValue.SelectedItems.length > 0) {
                                                itemValue.SelectedItems.forEach(child => {
                                                    if (option.Id === child.Id) {
                                                        updateChildQuantities(child, itemValue.SelectedItems[optionIndex]?.Quantity.Amount, false);
                                                    }
                                                });
                                            }

                                            resolveRecursive();
                                        } else {
                                            itemValue.SelectedItems.splice(optionIndex, 1);
                                            resolveRecursive();
                                        }
                                    } else {
                                        resolveRecursive();
                                    }
                                } else {
                                    resolveRecursive();
                                }
                            } else {
                                resolveRecursive();
                            }
                        } else {
                            resolveRecursive();
                        }
                    } else {
                        for (let mod of item.SelectedModifierGroups) {
                            for (let childMod of mod.SelectedItems) {
                                reduceRecursive(childMod, modifier, parentValue)
                                    .then(() => resolve(updatedQuantities))
                                    .catch(reject);
                            }
                        }
                    }
                });
            };

            reduceRecursive(updatedQuantities[0], modifierVal, parent)
                .then(() => resolve(updatedQuantities))
                .catch(reject);
        });
    };

    //wrapper function to remove modifier qunatity
    const reduceQtyOfModifiers = (option, modifier, parent) => {
        return new Promise(async (resolve) => {
            const updated = await reduceParentQuantities(quantities, option, modifier, parent);
            setQuantities(updated);
            localStorage.setItem("QUANTITY", JSON.stringify(updated))
            resolve(true)
        })
    };

    //modiefier rule handler
    const getRule = (rules) => {
        if (rules?.MinPermitted === 1 && rules?.MaxPermitted === 1) {
            return "RULE_1"
        }
        if (rules?.MaxPermitted === 1) {
            return "RULE_2"
        }
        if (!rules?.IsMinPermittedOptional) {
            return "RULE_4"
        }
        if (rules?.MaxPermitted > 1) {
            return "RULE_3"
        }
    }

    // handle check box quantities
    const handleCheckbox = (option, parent, modVal, modifier) => {
        if (!option) return "";
        let ID = option.MenuItemID ? option.MenuItemID : option.CartItemID
        let obj = _.find(modVal?.SelectedItems, { CartItemID: ID });
        if (obj && obj.Quantity.Amount > 0) {
            reduceQtyOfModifiers(option, modifier, parent)
        } else {
            addQtyOfModifiers(option, modifier, parent)
        }
    }

    //handle radio quantity
    const getSelectedRadio = (modifier, modVal) => {
        return modifier?.ModifierOptions?.map((options) => {
            const option = _.find(data.Items, { MenuItemID: options.Id });
            if (!option) return "";
            let ID = option.MenuItemID ? option.MenuItemID : option.CartItemID

            let obj = _.find(modVal?.SelectedItems, { CartItemID: ID });

            if (obj && obj.Quantity.Amount > 0) {
                return obj
            } else {
                return ""
            }
        }).filter(val => val !== "")[0]

    }
    const calculateTotalPrice = () => {
        const cartItem = quantities[0]
        let type = getType()
        if (cartItem) {
            const calculateModifierPrice = (modifierGroups, type) => {
                let total = 0;

                modifierGroups.forEach(group => {
                    group.SelectedItems.forEach(item => {
                        total += (item.PriceInfo.BaseTotalPrice[type]?.Amount * item.Quantity.Amount) || 0;
                        if (item.SelectedModifierGroups?.length) {
                            total += calculateModifierPrice(item.SelectedModifierGroups, type);
                        }
                    });
                });

                return total;
            };
            let totalPrice = cartItem.PriceInfo.BaseTotalPrice[type]?.Amount || 0;

            if (cartItem.SelectedModifierGroups?.length) {
                totalPrice += calculateModifierPrice(cartItem.SelectedModifierGroups, type);
            }

            return {
                Amount: totalPrice,
                FormattedText: `£${(totalPrice / 100).toFixed(2)}`,
                FormattedAmount: totalPrice / 100
            };
        }
    };
    //render modifiers
    const renderModifiers = (modifier, parent, modVal) => {
        if (!modifier) return null;
        let rule = getRule(modifier?.QuantityConstraintsRules?.Quantity)
        let radio = getSelectedRadio(modifier, modVal)
        return (
            <div key={modifier.ModifierGroupID} className="modifier">
                <div className="single-item" onClick={() => toggleModifierGroup(modifier.ModifierGroupID)}>
                    {modifier.Title.en.toCapitalFirst()}
                    <div className="left">{rule === "RULE_1" ? <div className="req">Required</div> : ""}
                        <img alt="arrow" src={arrow} className={`arrow-icon ${isOpen.includes(modifier.ModifierGroupID) ? "open" : ""}`} />
                    </div>

                </div>

                <Radio.Group
                    style={{ width: "100%" }}
                    onChange={async (e) => {
                        const selectedOption = e.target.value;
                        if (!selectedOption) return;

                        const selectedItem = _.find(data.Items, { MenuItemID: selectedOption.Id });
                        if (modVal) {
                            let selectedModifierObj = _.find(modVal.SelectedItems, { CartItemID: selectedItem?.MenuItemID });
                            if (!selectedModifierObj || selectedModifierObj.Quantity.Amount === 0) {
                                addQtyOfModifiers(selectedOption, modifier, parent);
                            }

                            const optionIndex = modVal.SelectedItems.findIndex(o => o.CartItemID === selectedItem?.MenuItemID);
                            if (optionIndex === -1) {
                                modVal.SelectedItems.map(async (modifiers) => {
                                    const object = modifier?.ModifierOptions?.find(options =>
                                        options.Id === modifiers.CartItemID
                                    );
                                    const modIndex = modVal.SelectedItems.findIndex(o => o.CartItemID === modifiers.MenuItemID);
                                    if (object) {
                                        modVal.SelectedItems.splice(modIndex, 1);
                                        return await reduceQtyOfModifiers(object, modifier, parent);
                                    }
                                });
                                if (modVal.SelectedItems.length === 0) {
                                    addQtyOfModifiers(selectedOption, modifier, parent);
                                }
                            } else {
                                await reduceQtyOfModifiers(selectedOption, modifier, parent);
                            }
                        } else {
                            addQtyOfModifiers(selectedOption, modifier, parent);

                        }


                    }}
                    value={radio}

                >


                    {isOpen.includes(modifier.ModifierGroupID) &&
                        <>
                            {rule === "RULE_4" && <div className="res">*atleast you have to choose {modifier?.QuantityConstraintsRules?.Quantity?.MinPermitted} items</div>}
                            {rule === "RULE_3" && <div className="res">*you can only choose up to {modifier?.QuantityConstraintsRules?.Quantity?.MaxPermitted} items</div>}
                            {rule === "RULE_3" && modVal?.
                                SelectedItems.length > 0 && modVal?.
                                    SelectedItems.reduce((sum, item) => sum + item.Quantity.Amount, 0) > modifier?.QuantityConstraintsRules?.Quantity?.MaxPermitted && <div className="res" style={{ color: "red" }}>*you have chosen {modVal?.
                                        SelectedItems.reduce((sum, item) => sum + item.Quantity.Amount, 0)} items, please choose {modifier?.QuantityConstraintsRules?.Quantity?.MaxPermitted} items</div>}
                            {modifier?.ModifierOptions?.map((options) => {
                                const optionValue = _.find(data.Items, { MenuItemID: options.Id });
                                const newOption = { ...optionValue, ParentID: parent.Id, Id: uuidv4(), SelectedModifierGroups: [] }
                                let obj = _.find(modVal?.SelectedItems, { CartItemID: optionValue.MenuItemID });
                                const selectedItem = _.find(data.Items, { MenuItemID: optionValue.MenuItemID });
                                let newObj = { ...obj, ModifierGroupRules: selectedItem.ModifierGroupRules }
                                let option = obj ? newObj : newOption
                                let radioOption = obj ? obj : newOption

                                if (!option) return null;
                                return (
                                    <div className="modifier-option-container" key={options.Id}>
                                        <div className="modifier-details">
                                            {rule === "RULE_1" ? (
                                                <Radio style={{ marginTop: "-6px" }} value={radioOption} />
                                            ) : (rule === "RULE_2" || rule === "RULE_4") ? (
                                                <Checkbox style={{ marginTop: "-6px", marginRight: "10px" }}
                                                    onChange={() => { handleCheckbox(option, parent, modVal, modifier) }}
                                                    checked={obj?.Quantity.Amount && obj?.Quantity.Amount > 0 ? true : false} />
                                            ) : null}

                                            <div className="option-name">
                                                <div className="item-name"> {option.Title.en ? option.Title.en.toCapitalFirst() : option.Title.toCapitalFirst()}</div>
                                                <div className="price-val">{obj ? getPriceSelectedOption(obj) : getOptionPrice(option.PriceInfo.Overrides, modifier.ModifierGroupID, obj?.Quantity.Amount || 1)}</div>
                                            </div>

                                            {rule === "RULE_3" && (
                                                <div className="qlt-option">
                                                    <div className="icon-cont" onClick={() => reduceQtyOfModifiers(option, modifier, parent)}>
                                                        <Icon name="minus" className="icon" />
                                                    </div>
                                                    <div className="qty-cont">
                                                        {obj?.Quantity.Amount || 0}
                                                    </div>
                                                    <div className="icon-cont" onClick={() => {
                                                        if (modifier.QuantityConstraintsRules.Quantity.MaxPermittedUnique > 0 && (obj?.Quantity.Amount || 0) < modifier.QuantityConstraintsRules.Quantity.MaxPermittedUnique) {
                                                            addQtyOfModifiers(option, modifier, parent)
                                                        }
                                                    }}>
                                                        <Icon name="plus" className="icon" />
                                                    </div>
                                                </div>
                                            )}
                                        </div>

                                        <div className="option-modifier">
                                            {quantities?.length > 0 && option?.ModifierGroupRules?.IDs?.map((mod) => {
                                                const newMod = obj && obj?.SelectedModifierGroups ? _.find(obj.SelectedModifierGroups, { ID: mod }) : null;
                                                const nestedModifier = _.find(data.ModifierGroups, { ModifierGroupID: mod });
                                                const modifierWithID = { ...nestedModifier, ParentID: option.Id }
                                                if (obj && obj.Quantity.Amount > 0) {
                                                    return renderModifiers(modifierWithID, option, newMod);
                                                }
                                                return null;
                                            })}
                                        </div>
                                    </div>
                                );
                            })}
                        </>

                    }
                </Radio.Group>

            </div >
        );
    };
    const getNutritionFacts = () => {
        const value = item?.NutrientData;

        const nutrients = [
            { label: 'Kcal', value: value?.Calories?.EnergyInterval?.Upper ?? 'N/A' },
            { label: 'Proteins', value: `${value?.Protein?.Amount?.Interval?.Upper ?? 'N/A'} ${value?.Protein?.Amount?.Weight?.UnitType ?? ''}` },
            { label: 'Fats', value: `${value?.Fat?.Amount?.Interval?.Upper ?? 'N/A'} ${value?.Fat?.Amount?.Weight?.UnitType ?? ''}` },
            { label: 'Carbo H', value: `${value?.Carbohydrates?.Amount?.Interval?.Upper ?? 'N/A'} ${value?.Carbohydrates?.Amount?.Weight?.UnitType ?? ''}` },
        ];

        return (
            <div className="nutri">
                <Typography bold={true} className="nutri-title">Nutritional value per 100g</Typography>
                <div className="servings-container">
                    {nutrients.map((nutrient, index) => (
                        <div className="serving-text-cont" key={index}>
                            <Typography bold={true} className="serving-text-head">{nutrient.value}</Typography>
                            <Typography className="serving-text">{nutrient.label}</Typography>
                        </div>
                    ))}
                </div>
            </div>
        );
    };


    const getDetailsData = () => {
        if (selectedDetails === "Ingredients") {
            return <>
                <div className="eco-mb-24">
                    This product contains ingredients that may trigger allergies. Please review the ingredient list for details.

                </div>
                <div className="det">
                    {(item?.DishInfo?.Classifications?.Ingredients?.map((ingredient) => (<div className="item">{ingredient}</div>)))}
                </div>
            </>
        }
        else if (selectedDetails === "Nutritional") {
            return getNutritionFacts()
        }
        else if (selectedDetails === "Allergies") {
            return (
                <div className="det">
                    {(item?.Allergens?.map((allergen) => (<div className="item">{allergen}</div>)))}
                </div>
            )
        }
        else {
            return (item?.DishInfo?.Classifications?.InstructionsForUse)
        }
    }
    const renderSpiceImages = (level) => {
        const fullImages = Math.floor(level / 2);
        const hasHalfImage = (level % 2) !== 0;
        const images = Array.from({ length: fullImages }, (_, index) => (
            <img key={index} src={spiceImage} alt="spice-level" style={{ width: '20px' }} />
        ));
        if (hasHalfImage) {
            images.push(
                <span key="half" style={{ display: 'flex', width: '12px', overflow: 'hidden' }}>
                    <img src={spiceImage} alt="half-spice-level" style={{ width: '20px' }} />
                </span>
            );
        }

        return images;
    };
    const updateSpecialInstructionForFirstItem = (newInstruction) => {
        setQuantities((prevCartItems) => {
            const updatedCartItems = [...prevCartItems];
            updatedCartItems[0] = {
                ...updatedCartItems[0],
                CustomerRequests: {
                    ...updatedCartItems[0].CustomerRequests,
                    SpecialInstructions: newInstruction
                }
            };

            return updatedCartItems;
        });
    };
    return (
        item && (
            <div className="VoucherDefaultSingleItemPage">
                <div className="item-details ">
                    <div xs={12} className="item-details-left">
                        <img
                            alt={item?.Title?.en ?? "No Image Available"}
                            src={item?.ImageURL || IMAGE_PLACEHOLDER}
                            className="item-image"
                            style={{ objectFit: !item.ImageURL ? "fill" : "" }}
                        />
                        <div className="description">
                            <div className="item-details-tab">
                                {showContent(item).map((detail) => {
                                    return (
                                        <div
                                            key={detail}
                                            className={`det-itm ${selectedDetails === detail ? "selected" : ""}`}
                                            onClick={() => setSelectedDetails(detail)}
                                        >
                                            {detail}
                                        </div>
                                    )
                                }
                                )}
                            </div>
                            <div className="item-tab-desc">
                                {getDetailsData()}
                            </div>
                        </div>
                    </div>
                    <div className="item-details-right" xs={12}>

                        <div className="title">
                            {item?.Title?.en.toCapitalFirst()}
                        </div>
                        {/* <div className="review">
                            <img alt="star" src={star} className="star" />
                            {item.TotalReviews}
                        </div> */}
                        <div className="price-conatiner">
                            <div className="item-price">
                                {calculateTotalPrice().FormattedText}
                            </div>
                            <div className="quantity">

                                {item?.Quantity === 1 && params.itemId !== "new" ?

                                    <div className="icon-cont" onClick={decreaseQty} > <img alt='' src={deleteIc} className='delete-icon' />  </div> : item?.Quantity === 1 ? <div className="empty-icon-cont"><Icon name="minus" className="icon" /></div> : <div className="icon-cont" onClick={decreaseQty} > <Icon name="minus" className="icon" /></div>}


                                <div className="qty-cont">
                                    {item?.Quantity || 0}
                                </div>

                                <div className="icon-cont" onClick={increaseQty}>
                                    <Icon name="plus" className="icon" />
                                </div>
                            </div>
                        </div>

                        <div className="item-details-data eco-mt-24">
                            {item?.DishInfo?.Classifications?.SpiceLevel > 0 && <Row><Col className="spice-cont">
                                <Typography className="spice-level">Spice Level</Typography>
                                <div className="spice-leve-img">{renderSpiceImages(item.DishInfo.Classifications.SpiceLevel)}</div>
                            </Col></Row>}
                            {item?.DishInfo?.Classifications?.IsVegetarian && <div className="vegan">Vegan</div>}

                        </div>
                        <div className="details">
                            {item?.Description?.en.toCapitalFirst()}  </div>

                        <div className="bottom-container">
                            <div className="quantity">


                                {item?.Quantity === 1 && params.itemId !== "new" ? <div className="icon-cont" onClick={decreaseQty}> <img alt='' src={deleteIc} className='delete-icon' /></div> : item?.Quantity === 1 ? <div className="empty-icon-cont" ><Icon name="minus" className="icon" /> </div> : <div className="icon-cont" onClick={decreaseQty}> <Icon name="minus" className="icon" /></div>}

                                <div className="qty-cont">
                                    {item?.Quantity || 0}
                                </div>

                                <div className="icon-cont" onClick={increaseQty}>
                                    <Icon name="plus" className="icon" />
                                </div>
                            </div>
                            <div className="sec-btn" onClick={async () => {
                                setIsLoading(true)
                                let data = { ...cartDetails, Cart: quantities[0] }
                                await addToCart(data).then((response) => {
                                    if (response) {
                                        history.push('/')
                                        setIsLoading(false)
                                    }
                                }).catch(() => {
                                    setIsLoading(false)
                                })
                            }}>
                                {isLoading && <div className="loader-btn" />}
                                {params.itemId !== "new" ? "Update Cart" :
                                    " Add to Cart"}
                            </div>
                        </div>
                        <div className="description">
                            <div className="item-details-tab">
                                {showContent(item).map((detail) => {
                                    return (
                                        <div
                                            key={detail}
                                            className={`det-itm ${selectedDetails === detail ? "selected" : ""}`}
                                            onClick={() => setSelectedDetails(detail)}
                                        >
                                            {detail}
                                        </div>
                                    )
                                }
                                )}
                            </div>
                            <div className="item-tab-desc">
                                {getDetailsData()}
                            </div>
                        </div>
                        <div className="modifiers">
                            {item?.ModifierGroupRules?.IDs.map((idVal) => {
                                const modifier = _.find(data?.ModifierGroups, { ModifierGroupID: idVal });
                                const newMod = quantities[0]?.SelectedModifierGroups && quantities[0]?.SelectedModifierGroups?.length > 0 ? _.find(quantities[0]?.SelectedModifierGroups, { ID: modifier?.ModifierGroupID }) : null
                                const modifierWithID = { ...modifier, ParentID: quantities[0].Id }
                                if (modifier) {
                                    return renderModifiers(modifierWithID, quantities[0], newMod);
                                }
                            })}
                        </div>

                        <div className="comments-sec">
                            <div className="comments-title" >
                                Add Comments (Optional)
                            </div>
                            <TextArea
                                placeholder="Comment here"
                                value={comments}
                                onChange={(e) => {
                                    setComments(e.target.value)
                                    updateSpecialInstructionForFirstItem(e.target.value)
                                }}
                                className="text-area"
                            />
                        </div>

                    </div>
                </div>


                <DeletePopup
                    visibility={isDelete}
                    onPopupClose={() => {
                        setIsDelete(false)
                    }}
                    onDeleteConfirm={handleDelete} />
            </div>
        )
    );
};


export default VoucherDefaultSingleItemPage;
